import { c as _c } from "react/compiler-runtime";
import React, { use } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import SuspenseWithLoader from '../SuspenseWithLoader';
import buildPdpDesktopHeroLcpUrl from './PDPDesktopHeroGallery/helpers/buildPdpDesktopHeroLcpUrl';
import PDPContextRegion from './PDPContextRegion';
import PDPContextRegionPlaceholder from './PDPContextRegionPlaceholder';

/**
 * Resolves only hero-related server promises so LCP preload (and the context
 * fallback hero image) can paint without waiting on options / basicDetails /
 * stock / protection.
 */
const PDPHeroShell = t0 => {
  const $ = _c(23);
  const {
    slugOverride: t1,
    isEditOrder: t2,
    pdpIsModularBYOProduct: t3,
    productOptionsPromise,
    productHeroImagePromise,
    productCylindoHeroImagePromise,
    productBasicDetailsPromise
  } = t0;
  const slugOverride = t1 === undefined ? null : t1;
  const isEditOrder = t2 === undefined ? false : t2;
  const pdpIsModularBYOProduct = t3 === undefined ? false : t3;
  const productHeroImageFromServer = productHeroImagePromise ? use(productHeroImagePromise) : null;
  const productCylindoHeroImage = productCylindoHeroImagePromise ? use(productCylindoHeroImagePromise) : null;
  const heroSrcForPreload = productHeroImageFromServer?.src || productCylindoHeroImage?.src || null;
  let t4;
  if ($[0] !== heroSrcForPreload) {
    t4 = heroSrcForPreload ? buildPdpDesktopHeroLcpUrl(heroSrcForPreload) ?? heroSrcForPreload : null;
    $[0] = heroSrcForPreload;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const heroPreloadHref = t4;
  let t5;
  if ($[2] !== heroPreloadHref) {
    t5 = heroPreloadHref ? <Helmet><link rel="preload" as="image" href={heroPreloadHref} media="(min-width: 1024px)" fetchPriority="high" /></Helmet> : null;
    $[2] = heroPreloadHref;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== isEditOrder || $[5] !== pdpIsModularBYOProduct || $[6] !== productCylindoHeroImage || $[7] !== productHeroImageFromServer) {
    t6 = <PDPContextRegionPlaceholder productHeroImage={productHeroImageFromServer} productCylindoHeroImage={productCylindoHeroImage} isEditOrder={isEditOrder} pdpIsModularBYOProduct={pdpIsModularBYOProduct} />;
    $[4] = isEditOrder;
    $[5] = pdpIsModularBYOProduct;
    $[6] = productCylindoHeroImage;
    $[7] = productHeroImageFromServer;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== isEditOrder || $[10] !== pdpIsModularBYOProduct || $[11] !== productBasicDetailsPromise || $[12] !== productCylindoHeroImage || $[13] !== productHeroImageFromServer || $[14] !== productOptionsPromise || $[15] !== slugOverride) {
    t7 = <PDPContextRegion slugOverride={slugOverride} isEditOrder={isEditOrder} pdpIsModularBYOProduct={pdpIsModularBYOProduct} productOptionsPromise={productOptionsPromise} productBasicDetailsPromise={productBasicDetailsPromise} productHeroImageFromServer={productHeroImageFromServer} productCylindoHeroImage={productCylindoHeroImage} />;
    $[9] = isEditOrder;
    $[10] = pdpIsModularBYOProduct;
    $[11] = productBasicDetailsPromise;
    $[12] = productCylindoHeroImage;
    $[13] = productHeroImageFromServer;
    $[14] = productOptionsPromise;
    $[15] = slugOverride;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t6 || $[18] !== t7) {
    t8 = <SuspenseWithLoader fallback={t6}>{t7}</SuspenseWithLoader>;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t5 || $[21] !== t8) {
    t9 = <>{t5}{t8}</>;
    $[20] = t5;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
};
PDPHeroShell.propTypes = {
  slugOverride: PropTypes.string,
  isEditOrder: PropTypes.bool,
  pdpIsModularBYOProduct: PropTypes.bool,
  productOptionsPromise: PropTypes.object,
  productHeroImagePromise: PropTypes.object,
  productCylindoHeroImagePromise: PropTypes.object,
  productBasicDetailsPromise: PropTypes.object
};
export default PDPHeroShell;